import { z } from 'zod';

export const AfcUserNotificationInlineAccountReassignSchema = z.object({
  id: z.string().uuid(),
  oldAccountId: z.string().uuid().nullable(),
  newAccountId: z.string().uuid().nullable(),
});
export type AfcUserNotificationInlineAccountReassign = z.infer<
  typeof AfcUserNotificationInlineAccountReassignSchema
>;

export const AfcUsersNotificationInlineSchema = z.object({
  accountReassign: z.array(AfcUserNotificationInlineAccountReassignSchema),
});
export type AfcUsersNotificationInline = z.infer<
  typeof AfcUsersNotificationInlineSchema
>;
